<template>
  <div>
    <div class="dflex mt-4">
      <div class="col row">
        <label class="vform-editor-label section mt-0">File</label>
      </div>
      <div
          v-for="(key, index2) in Object.keys(element.label.dix)"
          v-if="$store.getters.getSelectedFormLanguage === key"
          :key="index2 + 1000000000 + forceReRenderKey"
          class="dflex col-auto pr-0"
      >
        <div>
          <v-form-image-dix-cell
              :element="element"
              :image-dix="element.label.imageDix"
              :media-category="3"
              :organization-id="organizationId"
              :v-s-t-a-g-e-context="vSTAGEContext"
              preview-size="medium"
          />
        </div>
      </div>
    </div>
    <div class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">Alignment</label>
      </div>
      <div
          v-for="(align, index) in alignments"
          :key="index"
          :class="[
                    'vform-alignment-button',
                    align === element.alignment ? 'active' : '',
                ]"
          @click="setAlignment(align)"
      >
        <icon :type="'align-' + align" size="1"/>
      </div>
    </div>
    <label class="vform-editor-label section">Scale</label>
    <label class="section ml-2 vform-editor-body slider-label"
    >{{ this.size ? `${this.size}%` : 'AUTO' }}</label
    >
    <slider :default-value="null" :initial-value="size"
            :interval="10" :max="100" :min="0"
            @change="(val) => { this.$set(this, 'size', val) }"></slider>
    <div class="col pl-0 pr-0 dflex">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{ $t("showAsTile") }}</label>
      </div>
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <div v-if="true" class="col-12 dflex row">
          <label :for="'chkshowastiles' + $vnode.key" class="container" style="padding-left: 5px !important">
            <input
                :id="'chkshowastiles' + $vnode.key"
                v-model="element.showastiles"
                type="checkbox"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="col pl-0 pr-0 dflex">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{
            $t("vform.noMarginBottom")
          }}</label>
      </div>
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label
            :for="'removeMarginBottom' + $vnode.key"
            class="container"
            style="padding-left: 5px !important"
        >
          <input
              :id="'removeMarginBottom' + $vnode.key"
              v-model="element.noMarginBottom"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <div class="col pl-0 pr-0 dflex" v-if="state && state.isTopBottomBarPanel">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{ $t("showInline") }}</label>
      </div>
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label :for="'showInline' + $vnode.key" class="container" style="padding-left: 5px !important">
          <input :id="'showInline' + $vnode.key" v-model="element.isInline" type="checkbox">
          <span class="checkmark"/>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import vFormImageDixCell from "@/components/vForm/vFormImageDixCell";
import {vFormControls} from "@/enum";
import Icon from "../Icon";
import Slider from "@/components/widgets/editors/Slider";

export default {
  name: "vFormIMAGE",
  components: {
    vFormImageDixCell,
    Slider,
    Icon,
  },
  props: {
    element: {type: Object, required: true},
    stepNo: {type: Number, required: true},
    organizationId: {type: String, default: ""},
    vSTAGEContext: {type: Boolean, default: false},
    state: {type: Object, default: null},
  },
  data() {
    return {
      forceReRenderKey: 0,
      editImage: "",
      vFormControls: vFormControls,
      size: 100,
      alignments: ["left", "center", "right"],
    };
  },
  watch: {
    'state.isTopBottomBarPanel'(newVal) {
      if (newVal) {
        this.$set(this.element, 'showastiles', false);
      }
    },
    size() {
      this.$set(this.element, "size", this.size);
    },
    element(newVal) {
      this.size = newVal.size ? newVal.size : 100;
    },
  },
  beforeMount() {
    this.element.formElementType = vFormControls["IMAGE"];
    this.size = this.element.size ? this.element.size : this.size;
    if (this.element.noMarginBottom === undefined) {
      this.$set(this.element, "marginBottom", false);
    }
    if (this.element.isInline === undefined) {
      this.$set(this.element, "isInline", false);
    }
    if (this.state && this.state.isTopBottomBarPanel) {
      this.$set(this.element, "showastiles", false);
    }
  },
  methods: {
    save() {
      this.$emit("save", this.element);
    },
    setAlignment(val) {
      this.$set(this.element, "alignment", val);
    },
  },
};
</script>
